<template>
    <transition name="toggleContentComponent">

        <article class="externalEmbed" :class="{ 'externalEmbed--fullscreen': fullscreen }" @click.stop v-if="ready">

            <iframe :src="properties.pageUrl" @click.stop :style="invertedScaleStyles"></iframe>
            <button class="close" @click="closeComponent()">
                <img src="@/assets/img/ui/box-close.svg" />
            </button>
        </article>

    </transition>
</template>


<script>

import Logo from "../../ui/Logo.vue";
export default {
    components: {
        Logo,
    },
    props: [
        "properties",
        "pageData",
        "slug"
    ],
    data() {
        return {
            ready: false,
            fullscreen: true,
        }
    },


    mounted() {

        this.ready = true;

    },
    beforeUnmount() {
        if (this.properties.omitAutoOpenIfClosed) {
            app.api.LocalDataStore.set(this.slug, true);
        }
    },
    methods: {
        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },


    },
    computed: {

        invertedScaleStyles() {
            // lets iframe content scale to always be 1! - despite any TK scale
            var currentScale = this.$store.getters.getScaleValue;
            var invertedScale = 1 / currentScale;
            var initScale = 100;
            return {
                'transform': `scale(${invertedScale})`,
                'height': `${currentScale * initScale}%`,
                'width': `${currentScale * initScale}%`
            }

        }
    }
};
</script>


<style lang="scss">
.externalEmbed {

    width: 1485px;
    height: 830px;
    border: var(--light-grey) 7px solid;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;


    &.fullscreenVideo {
        height: 100%;
        width: 100%;
    }

    &>video,
    &>iframe {
        height: 100%;
    }

    iframe {
        width: 100%;
        position: absolute;
        background-color: #000;
        pointer-events: all;
        border: none;
        border-radius: 2px;
    }

    button.close {
        position: absolute;
        right: -2px;
        top: -1px;
    }

    figure {
        position: absolute;
        bottom: -5px;

        span {

            position: absolute;
            display: flex;
            color: #3C3C3C;
            font-family: 'Arla Strong';
            font-size: 20px;
            gap: 10px;
            bottom: 4px;
            margin-left: -5px;
            justify-content: center;
            width: 100%;

            img {
                width: 23px;
                height: 17px;
            }
        }
    }

}
</style>